/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/manage.scss';
import Paging from '../../component/Inc/Paging';
import Tab from '../../component/Inc/Tab';
import PopDiscount from './_PopDiscount';
import PopGradeClass from './_PopGradeClass';
import PopSetProduct from './_PopSetProduct';
function GradeClass() {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '수시 단품 상품 관리', value: 0},
    {title: '세트 상품 관리', value: 1},
    {title: '보고서 관리', value: 2},
    {title: '교사 등급 관리', value: 3}
  ];
  const [modalDiscount, setModalDiscount] = useState(false);
  const [modalGradeClass, setModalGradeClass] = useState(false);
  const [modalSetProduct, setModalSetProduct] = useState(false);
  return (
    <main className="com_container p_manage_grade_class">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu9_7">수시상품 관리</h2>
          <div className="com_btn_wrap">
            {tabIdx === 0 && (
              <>
                <button onClick={() => setModalDiscount(true)} className="com_btn orange s">
                  상품 할인하기
                </button>
                <button onClick={() => setModalGradeClass(true)} className="com_btn orange s btn_plus">
                  수시 상품 등록
                </button>
              </>
            )}
            {tabIdx === 1 && (
              <>
                <button onClick={() => setModalDiscount(true)} className="com_btn orange s">
                  상품 할인하기
                </button>
                <button onClick={() => setModalSetProduct(true)} className="com_btn orange s btn_plus">
                  세트 상품 등록
                </button>
              </>
            )}
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요" className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <hr className="com_divider" />

            {tabIdx === 0 && (
              <>
                <div className="com_board_list__top">
                  <div className="board_select">
                    <div className="check">
                      <input type="radio" name="rdo_1" id="rdo01" className="com_chk circle" />
                      <label htmlFor="rdo01">전체</label>
                      <input type="radio" name="rdo_1" id="rdo02" className="com_chk circle" />
                      <label htmlFor="rdo02">논술</label>
                      <input type="radio" name="rdo_1" id="rdo03" className="com_chk circle" />
                      <label htmlFor="rdo03">생기부디자인</label>
                      <input type="radio" name="rdo_1" id="rdo04" className="com_chk circle" />
                      <label htmlFor="rdo04">정시컨설팅 </label>
                      <input type="radio" name="rdo_1" id="rdo05" className="com_chk circle" />
                      <label htmlFor="rdo05">수시컨설팅</label>
                      <input type="radio" name="rdo_1" id="rdo06" className="com_chk circle" />
                      <label htmlFor="rdo06">면접</label>
                      <input type="radio" name="rdo_1" id="rdo07" className="com_chk circle" />
                      <label htmlFor="rdo07">자소서</label>
                    </div>
                  </div>
                </div>
                <table className="com_board_list">
                  <colgroup>
                    <col width="60" />
                    <col width="90" />
                    <col width="90" />
                    <col width="100" />
                    <col width="90" />
                    <col width="100" />
                    <col width="110" />
                    <col width="auto" />
                    <col width="110" />
                    <col width="90" />
                    <col width="90" />
                    <col width="110" />
                    <col width="110" />
                    <col width="100" />
                    <col width="100" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>과목</th>
                      <th>상품명</th>
                      <th>코드</th>
                      <th>수업 방법</th>
                      <th>수업시간(분)</th>
                      <th>수업 체크 방법</th>
                      <th>보고서</th>
                      <th>상품가격(원)</th>
                      <th>지급 방법</th>
                      <th>교자별 지급</th>
                      <th>과세 여부</th>
                      <th>상태</th>
                      <th>수정</th>
                      <th>수정일</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>12</td>
                      <td className="td_point">
                        <button className="btn_link txt">논술60</button>
                      </td>
                      <td>논술60</td>
                      <td>132</td>
                      <td>1 : 1</td>
                      <td>80</td>
                      <td>보고서 작성</td>
                      <td>
                        보고서명 <button className="btn_link blue">다운로드</button>
                      </td>
                      <td className="td_point">600,000</td>
                      <td>정액제</td>
                      <td>
                        M : 25,00
                        <br />C : 15,000
                      </td>
                      <td>비과세</td>
                      <td>사용중</td>
                      <td>
                        <button className="btn_link blue">수정</button>
                      </td>
                      <td>
                        홍길동123
                        <br />
                        2024, 05, 12
                      </td>
                    </tr>

                    {[...Array(6)].map((i, idx) => (
                      <tr key={idx}>
                        <td>12</td>
                        <td className="td_point">
                          <button className="btn_link txt">논술60</button>
                        </td>
                        <td>논술60</td>
                        <td>132</td>
                        <td>1 : 1</td>
                        <td>80</td>
                        <td>보고서 작성</td>
                        <td>
                          <div>
                            보고서명 <button className="btn_link blue">다운로드</button>
                          </div>
                          <div>
                            보고서명 <button className="btn_link blue">다운로드</button>
                          </div>
                          <div>
                            보고서명 <button className="btn_link blue">다운로드</button>
                          </div>
                        </td>
                        <td>
                          <p className="line_through">120,000</p>
                          <p className="com_blue_txt"> 90,000</p>
                        </td>
                        <td>정액제</td>
                        <td>
                          M : 25,00
                          <br />C : 15,000
                        </td>
                        <td>비과세</td>
                        <td>사용중</td>
                        <td>
                          <button className="btn_link blue">수정</button>
                        </td>
                        <td>
                          홍길동123
                          <br />
                          2024, 05, 12
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <Paging />
              </>
            )}
            {tabIdx === 1 && (
              <>
                <div className="com_board_list__top">
                  <div className="board_select">
                    <div className="check">
                      <input type="radio" name="rdo_1" id="rdo01" className="com_chk circle" />
                      <label htmlFor="rdo01">전체</label>
                      <input type="radio" name="rdo_1" id="rdo02" className="com_chk circle" />
                      <label htmlFor="rdo02">논술</label>
                      <input type="radio" name="rdo_1" id="rdo03" className="com_chk circle" />
                      <label htmlFor="rdo03">생기부디자인</label>
                      <input type="radio" name="rdo_1" id="rdo04" className="com_chk circle" />
                      <label htmlFor="rdo04">정시컨설팅 </label>
                      <input type="radio" name="rdo_1" id="rdo05" className="com_chk circle" />
                      <label htmlFor="rdo05">수시컨설팅</label>
                      <input type="radio" name="rdo_1" id="rdo06" className="com_chk circle" />
                      <label htmlFor="rdo06">면접</label>
                      <input type="radio" name="rdo_1" id="rdo07" className="com_chk circle" />
                      <label htmlFor="rdo07">자소서</label>
                    </div>
                  </div>
                </div>
                <table className="com_board_list">
                  <colgroup>
                    <col width="60" />
                    <col width="180" />
                    <col width="160" />
                    <col width="230" />
                    <col width="160" />
                    <col width="160" />
                    <col width="auto" />
                    <col width="160" />
                    <col width="160" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>NO</th>
                      <th>세트 상품 명</th>
                      <th>상품명</th>
                      <th>총 합계 금액</th>
                      <th>수업시간(분)</th>
                      <th>과세 여부</th>
                      <th>상태</th>
                      <th>수정</th>
                      <th>수정일</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td rowSpan={3}>1</td>
                      <td rowSpan={3}>논술세트 상품</td>

                      <td className="td_point">
                        <button className="btn_link txt">논술40</button>
                      </td>
                      <td rowSpan={3} className="td_point">
                        120,000
                      </td>
                      <td>120,000</td>
                      <td>비과세</td>
                      <td>
                        <div className="check">
                          <input type="radio" name="rdo_2" id="rdo2_1" className="com_chk circle" />
                          <label htmlFor="rdo2_1">사용</label>
                          <input type="radio" name="rdo_2" id="rdo2_2" className="com_chk circle" />
                          <label htmlFor="rdo2_2">미사용</label>
                        </div>
                      </td>
                      <td>
                        <button className="btn_link blue">수정</button>
                      </td>
                      <td>
                        홍길동123
                        <br />
                        2024, 02, 12
                      </td>
                    </tr>
                    <tr>
                      <td className="td_point">
                        <button className="btn_link txt">논술40</button>
                      </td>
                      <td>120,000</td>
                      <td>비과세</td>
                      <td>
                        <div className="check">
                          <input type="radio" name="rdo_2" id="rdo2_1" className="com_chk circle" />
                          <label htmlFor="rdo2_1">사용</label>
                          <input type="radio" name="rdo_2" id="rdo2_2" className="com_chk circle" />
                          <label htmlFor="rdo2_2">미사용</label>
                        </div>
                      </td>
                      <td>
                        <button className="btn_link blue">수정</button>
                      </td>
                      <td>
                        홍길동123
                        <br />
                        2024, 02, 12
                      </td>
                    </tr>
                    <tr>
                      <td className="td_point">
                        <button className="btn_link txt">논술40</button>
                      </td>
                      <td>120,000</td>
                      <td>비과세</td>
                      <td>
                        <div className="check">
                          <input type="radio" name="rdo_2" id="rdo2_1" className="com_chk circle" />
                          <label htmlFor="rdo2_1">사용</label>
                          <input type="radio" name="rdo_2" id="rdo2_2" className="com_chk circle" />
                          <label htmlFor="rdo2_2">미사용</label>
                        </div>
                      </td>
                      <td>
                        <button className="btn_link blue">수정</button>
                      </td>
                      <td>
                        홍길동123
                        <br />
                        2024, 02, 12
                      </td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>논술</td>
                      <td className="td_point">
                        <button className="btn_link txt">논술40</button>
                      </td>
                      <td className="td_point">
                        <span className="line_through"> 75,000 </span> -> 50,000(5%할인)
                      </td>
                      <td>120,000</td>
                      <td>비과세</td>
                      <td>
                        <div className="check">
                          <input type="radio" name="rdo_2" id="rdo2_1" className="com_chk circle" />
                          <label htmlFor="rdo2_1">사용</label>
                          <input type="radio" name="rdo_2" id="rdo2_2" className="com_chk circle" />
                          <label htmlFor="rdo2_2">미사용</label>
                        </div>
                      </td>
                      <td>
                        <button className="btn_link blue">수정</button>
                      </td>
                      <td>
                        홍길동123
                        <br />
                        2024, 02, 12
                      </td>
                    </tr>
                  </tbody>
                </table>
                <Paging />
              </>
            )}
            {tabIdx === 2 && (
              <>
                <div className="com_board_list__top">
                  <div className="board_select">
                    <div className="check">
                      <input type="radio" name="rdo_1" id="rdo01" className="com_chk circle" />
                      <label htmlFor="rdo01">전체</label>
                      <input type="radio" name="rdo_1" id="rdo02" className="com_chk circle" />
                      <label htmlFor="rdo02">논술</label>
                      <input type="radio" name="rdo_1" id="rdo03" className="com_chk circle" />
                      <label htmlFor="rdo03">생기부디자인</label>
                      <input type="radio" name="rdo_1" id="rdo04" className="com_chk circle" />
                      <label htmlFor="rdo04">정시컨설팅 </label>
                      <input type="radio" name="rdo_1" id="rdo05" className="com_chk circle" />
                      <label htmlFor="rdo05">수시컨설팅</label>
                      <input type="radio" name="rdo_1" id="rdo06" className="com_chk circle" />
                      <label htmlFor="rdo06">면접</label>
                      <input type="radio" name="rdo_1" id="rdo07" className="com_chk circle" />
                      <label htmlFor="rdo07">자소서</label>
                    </div>
                  </div>
                </div>
                <table className="com_board_list">
                  <colgroup>
                    <col width="70" />
                    <col width="70" />
                    <col width="200" />
                    <col width="200" />
                    <col width="auto" />
                    <col width="200" />
                    <col width="200" />
                    <col width="110" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>
                        <input type="checkbox" name="chk" id="chkAll" className="com_chk" />
                        <label htmlFor="chkAll"></label>
                      </th>
                      <th>과목명</th>
                      <th>보고서명</th>
                      <th>보고서 양식</th>
                      <th>적용된 단품 상품 수</th>
                      <th>상태</th>
                      <th>수정</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...Array(6)].map((i, idx) => (
                      <tr key={idx}>
                        <td>12</td>
                        <td>
                          <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                          <label htmlFor="chk01"></label>
                        </td>
                        <td>논술</td>
                        <td className="td_point">
                          <button className="btn_link txt">논술60</button>
                        </td>
                        <td>
                          <div className="file_wrap">
                            <button className="btn_del_file"></button>
                            <span className="tit">파일명파일명파일명</span> <button className="btn_link blue">다운로드</button>
                          </div>
                        </td>
                        <td>80</td>
                        <td>
                          <div className="check">
                            <input type="radio" name="rdo_2" id="rdo2_1" className="com_chk circle" />
                            <label htmlFor="rdo2_1">사용</label>
                            <input type="radio" name="rdo_2" id="rdo2_2" className="com_chk circle" />
                            <label htmlFor="rdo2_2">미사용</label>
                          </div>
                        </td>
                        <td>
                          <button className="btn_link blue">수정</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="com_board_list__bottom">
                  <div className="com_btn_wrap left">
                    <button className="com_btn black xs">선택한 보고서중 적용수가 0인 상품 삭제</button>
                  </div>
                  <Paging />
                </div>
              </>
            )}

            {tabIdx === 3 && (
              <>
                <table className="com_board_list">
                  <colgroup>
                    <col width="250" />
                    <col width="250" />
                    <col width="250" />
                    <col width="250" />
                    <col width="auto" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>등급위치</th>
                      <th>등급명</th>
                      <th>메인 등급별 지급률 (%)</th>
                      <th>서브 교사시 지급률(%)</th>
                      <th>등록된 교사</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input type="text" className="input full" placeholder="입력" />
                      </td>
                      <td>
                        <input type="text" className="input full" placeholder="입력" />
                      </td>
                      <td>
                        <input type="text" className="input full" placeholder="입력" />
                      </td>
                      <td>
                        <input type="text" className="input full" placeholder="입력" />
                      </td>
                      <td>
                        <section className="com_board_search end">
                          <article className="search full">
                            <input type="search" placeholder="검색할 내용을 입력해 주세요" className="input  type_search" />
                            <button className="com_btn gray ws s icon_search"></button>
                          </article>
                        </section>
                        <div className="multiple_file_wrap">
                          <div className="item">
                            <button className="btn_del_file"></button>
                            <span className="tit">홍길동</span>
                          </div>
                          <div className="item">
                            <button className="btn_del_file"></button>
                            <span className="tit">홍길동</span>
                          </div>
                          <div className="item">
                            <button className="btn_del_file"></button>
                            <span className="tit">홍길동</span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="com_btn_wrap center bottom">
                  <button className="com_btn orange xs">등록</button>
                </div>
              </>
            )}
          </section>

          {/* 보고서 관리 수정 클릭시 */}
          {tabIdx === 2 && (
            <section className="box full">
              <div className="detail_tit dot">보고서 등록 & 수정</div>
              <table className="com_board_list">
                <colgroup>
                  <col width="400" />
                  <col width="400" />
                  <col width="250" />
                  <col width="auto" />
                </colgroup>
                <thead>
                  <tr>
                    <th>과목 선택</th>
                    <th>보고서명</th>
                    <th>상태</th>
                    <th>보고서 양식</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <select name="" id="" className="select full">
                        <option value="">논술</option>
                      </select>
                    </td>
                    <td>
                      <input type="text" className="input full" />
                    </td>
                    <td>
                      <div className="check">
                        <input type="radio" name="rdo_2" id="rdo2_1" className="com_chk circle" />
                        <label htmlFor="rdo2_1">사용</label>
                        <input type="radio" name="rdo_2" id="rdo2_2" className="com_chk circle" />
                        <label htmlFor="rdo2_2">미사용</label>
                      </div>
                    </td>
                    <td>
                      <div className="file_wrap">
                        <button className="btn_del_file"></button>
                        <span className="tit">파일명파일명파일명</span> <button className="com_btn gray xxs">파일 찾기</button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="com_btn_wrap center bottom">
                <button className="com_btn orange xs">등록 & 저장</button>
              </div>
            </section>
          )}
          {tabIdx === 3 && (
            <section className="box full">
              <table className="com_board_list">
                <colgroup>
                  <col width="70" />
                  <col width="150" />
                  <col width="150" />
                  <col width="200" />
                  <col width="200" />
                  <col width="auto" />
                  <col width="100" />
                </colgroup>
                <thead>
                  <tr>
                    <th>
                      <input type="checkbox" name="chk" id="chkAll" className="com_chk" />
                      <label htmlFor="chkAll"></label>
                    </th>
                    <th>등급위치</th>
                    <th>등급명</th>
                    <th>메인 등급별 지급률 (%)</th>
                    <th>서브 교사시 지급률(%)</th>
                    <th>등록된 교사</th>
                    <th>수정</th>
                  </tr>
                </thead>
                <tbody>
                  {[...Array(6)].map((i, idx) => (
                    <tr key={idx}>
                      <td>
                        <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                        <label htmlFor="chk01"></label>
                      </td>
                      <td>{idx + 1}</td>
                      <td>SS</td>
                      <td className="td_point">80</td>
                      <td className="td_point">80</td>
                      <td className="td_left">홍길동123&nbsp;홍길동123&nbsp;홍길동123 </td>
                      <td>
                        <button className="btn_link blue">수정</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="com_btn_wrap bottom">
                <button className="com_btn black xs">선택한 항목 삭제</button>
              </div>
            </section>
          )}
        </section>
      </div>
      <PopDiscount open={modalDiscount} close={() => setModalDiscount(false)} />
      <PopGradeClass open={modalGradeClass} close={() => setModalGradeClass(false)} />
      <PopSetProduct open={modalSetProduct} close={() => setModalSetProduct(false)} />
    </main>
  );
}

export default GradeClass;
